import classNames from 'classnames';
import { forwardRef } from 'react';
const meetingCardContainerHasUrlCss = "m13afdb6";
const meetingCardContainerIsFetchingCss = "myen9b5";
const meetingCardContainerIsSelectedCss = "m16dyzqo";
const checkboxContainerCss = "c17bp2yf";
const meetingCardContainerCss = "m1sn4llf";
export const MeetingCardContainer = forwardRef((props, ref) => {
  const {
    hasUrl,
    isFetching,
    isSelected,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(meetingCardContainerCss, {
    [meetingCardContainerHasUrlCss]: hasUrl,
    [meetingCardContainerIsFetchingCss]: isFetching,
    [meetingCardContainerIsSelectedCss]: isSelected
  }, props.className)} />;
});
export const CheckboxContainer = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(checkboxContainerCss, props.className)} />);
const thumbnailContainerCss = "tyvu74t";
export const ThumbnailContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(thumbnailContainerCss, props.className)} />;
});
const thumbnailLoaderCss = "t1huf2ui";
export const ThumbnailLoader = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(thumbnailLoaderCss, props.className)} />;
});
const thumbnailCss = "t111sbdg";
export const Thumbnail = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'img';
  return <Component ref={ref} {...restProps} className={classNames(thumbnailCss, props.className)} />;
});
const thumbnailPlaceholderCss = "tu2xd7z";
export const ThumbnailPlaceholder = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(thumbnailPlaceholderCss, props.className)} />;
});
const meetingTimeBadgeCss = "mlvk9t5";
export const MeetingTimeBadge = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(meetingTimeBadgeCss, props.className)} />;
});
const sampleBadgeCss = "scxcsk0";
export const SampleBadge = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(sampleBadgeCss, props.className)} />;
});
const bodyContainerCss = "b496iru";
export const BodyContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(bodyContainerCss, props.className)} />;
});
const nameContainerCss = "n1d29a6c";
export const NameContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(nameContainerCss, props.className)} />;
});

// Width clamp for the title. NameContainer is a flex column with
// `align-items: flex-start`, which sizes TitleText to its content width — so the
// inner ellipsis span never overflows and no ellipsis renders. Forcing the
// wrapper to `width: 100%` (an explicit size overrides the flex-start shrink)
// constrains the title to the container so truncation actually kicks in.
const titleClampCss = "tegt283";
export const TitleClamp = forwardRef((props, ref) => <span ref={ref} {...props} className={classNames(titleClampCss, props.className)} />);

// Single-line ellipsis truncation for the recap title. This must live on an inner
// element rather than on TitleText itself: TitleText is wrapped in withNoCssOverrides,
// which strips `className`/`style`, so truncation CSS applied to it is silently dropped.
const nameTitleCss = "n18dedax";
export const NameTitle = forwardRef((props, ref) => <span ref={ref} {...props} className={classNames(nameTitleCss, props.className)} />);
const dateTimeChildItemCss = "ddzgv2t";
const dateTimeContainerCss = "d1yn4az";
export const DateTimeContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(dateTimeContainerCss, props.className)} />;
});
const metadataDotCss = "m1saph6z";
export const MetadataDot = forwardRef((props, ref) => <span ref={ref} {...props} className={classNames(metadataDotCss, dateTimeChildItemCss, props.className)} />);
const timeContainerCss = "tfycu2s";
export const TimeContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(timeContainerCss, dateTimeChildItemCss, props.className)} />;
});
const dateContainerCss = "dlvzr8f";
const ownedByContainerCss = "o1ladhq3";
export const OwnedByContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(ownedByContainerCss, dateTimeChildItemCss, props.className)} />;
});
export const DateContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(dateContainerCss, dateTimeChildItemCss, props.className)} />;
});
const linkWrapperCss = "l4m9nem";
export const LinkWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'a';
  return <Component ref={ref} {...restProps} className={classNames(linkWrapperCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");